/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MotorLabData } from './MotorLabData';
import type { MotorState } from './MotorState';
import type { MotorThermalLimits } from './MotorThermalLimits';
import type { ThermalModel } from './ThermalModel';
/**
 * Motor in Database.
 */
export type MotorLabInDB = {
    item_type?: MotorLabInDB.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: 'MotorLabModel';
    lab_data: MotorLabData;
    max_speed: number;
    flow_rate?: number;
    state?: MotorState;
    thermal_model?: (ThermalModel | null);
    thermal_limits?: MotorThermalLimits;
    _id?: string;
};
export namespace MotorLabInDB {
    export enum item_type {
        COMPONENT = 'component',
    }
}

